module.exports = __webpack_public_path__ + "static/media/1.966ae97b.jpg";